import hasIn from 'ramda/es/hasIn';

const nope = (e) => {
  if (e && typeof e === 'object' && hasIn('preventDefault', e)) {
    e.preventDefault();
  }
};

export default nope;
